const SCRIPT_ID = 'utmify-utms-script'
const SCRIPT_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js'

/**
 * Loads the official UTMify tracking script globally, on every page load.
 * It captures the UTM parameters from the URL, persists them across the
 * session, and forwards conversion attribution to UTMify by carrying them
 * through to the checkout.
 *
 * Called from the app entry point so attribution is captured before render.
 * A blocked third-party script is intentionally non-fatal, so ad blockers or
 * network failures can never prevent the sales page from loading.
 */
export function loadUtmify() {
  try {
    if (typeof document === 'undefined') return
    if (document.getElementById(SCRIPT_ID)) return

    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.src = SCRIPT_SRC
    script.async = true
    script.defer = true
    script.setAttribute('data-utmify-prevent-xcod-sck', '')
    script.setAttribute('data-utmify-prevent-subid', '')
    script.onerror = () => {
      script.remove()
    }

    document.head.appendChild(script)
  } catch {
    // Attribution must never block the sales page from rendering.
  }
}
